import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import isEmpty from 'lodash.isempty';

import { getUser, getLoadingStatus, getSavingStatus } from '../../../../redux/user/selectors';
import { userActions } from '../../../../redux/user/actions';

export const useUserData = () => {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const [userFormData, setUserFormData] = useState();
  const userData = useSelector(getUser);
  const loading = useSelector(getLoadingStatus);
  const saving = useSelector(getSavingStatus);

  useEffect(() => {
    if (!userId) return;

    dispatch(userActions.loadUser(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    if (!userData) return;

    setUserFormData({
      ...userData,
      companies: isEmpty(userData.companies) ? [] : userData.companies.map(company => company._id),
    });
  }, [userData]);

  return { userFormData, loading, saving };
};
